import {Button} from "@/components/ui/button.tsx";

export default function ErrorPage() {
    return (
        <div className={"flex flex-col items-center justify-center gap-4 w-screen h-screen"}>
            <p className={"text-3xl"}>Hoppá, hiba történt!</p>
            <p className={"text-xl"}>Már dolgozunk rajta!</p>
            <Button onClick={()=> window.location.reload()}>
                Újratöltés
            </Button>
        </div>
    )
}